var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat_Color",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.931,
    height: 32.901,
    viewBox: "0 0 32.931 32.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M17.7,34.151a16.451,16.451,0,1,1,0-32.9,16.114,16.114,0,0,1,7.376,1.76A1.15,1.15,0,0,1,24.036,5.06,13.773,13.773,0,0,0,17.7,3.53,14.155,14.155,0,1,0,31.856,17.7a3.061,3.061,0,0,0,0-.383,1.153,1.153,0,1,1,2.3-.214v.6A16.466,16.466,0,0,1,17.7,34.151Z",
    transform: "translate(-1.25 -1.25)",
    fill: "#20bf55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M14.773,21.506a1.071,1.071,0,0,1-.8-.337L6.586,13.916a1.148,1.148,0,0,1,0-1.622,1.178,1.178,0,0,1,1.637,0l6.565,6.473L29.556,4.245a1.178,1.178,0,0,1,1.637,0,1.148,1.148,0,0,1,0,1.622L15.615,21.17A1.132,1.132,0,0,1,14.773,21.506Z",
    transform: "translate(1.402 0.163)",
    fill: "#20bf55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.de42295b9ed67b94cdaae7a667e49953.svg";
export { ForwardRef as ReactComponent };